import './TotalScore.css';

interface TotalScoreProps {
  total: number;
  delta?: number;
  rank?: number;
  isFirstMonth?: boolean;
}

export function TotalScore({ total, delta, rank, isFirstMonth }: TotalScoreProps) {
  return (
    <div className="total-score">
      <div className="total-score__label">TOTAL SCORE</div>

      <div className="total-score__value-row">
        <span className="total-score__number">{total}</span>
        <span className="total-score__pts">PTS</span>
      </div>

      <div className="total-score__sub-bar">
        <div className="total-score__sub-left">
          {delta !== undefined && delta !== 0 ? (
            <span
              className={`total-score__delta ${delta > 0 ? 'total-score__delta--positive' : 'total-score__delta--negative'}`}
            >
              {delta > 0 ? '↑' : '↓'} {Math.abs(delta)} pts vs last mo
            </span>
          ) : isFirstMonth ? (
            <span className="total-score__sub-muted">First month</span>
          ) : (
            <span className="total-score__sub-muted">— vs last mo</span>
          )}
        </div>

        <div className="total-score__sub-right">
          {rank !== undefined ? (
            <span className="total-score__rank">Rank #{rank}</span>
          ) : (
            <span className="total-score__sub-muted">Rank —</span>
          )}
        </div>
      </div>
    </div>
  );
}
